import { Vue, Ref, Prop, Emit, Component } from 'vue-property-decorator'
import {
    CustomerTypesModalState, initialCustomerTypesModalState
} from '@/modules/configurationModule/detail/accounting/billable/customer-types/components/customer-types-modal/customer-types-modal.model'
import {
    CustomerTypeCreateRequest, CustomerTypePatchInBatchRequest,
    CustomerTypeResponse
} from '@/modules/configurationModule/detail/accounting/billable/customer-types/services/customer-types.dto'

@Component({})
export default class CustomerTypesModal extends Vue {
    @Ref() readonly customerTypesModal!: any

    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): CustomerTypeCreateRequest {
        return { active: this.state.active, code: this.state.code, name: this.state.name }
    }

    @Emit()
    update(): CustomerTypePatchInBatchRequest {
        return this.state
    }

    state: CustomerTypesModalState
    constructor() {
        super()
        this.state = initialCustomerTypesModalState()
    }

    async show(customerType?: CustomerTypeResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialCustomerTypesModalState()
        if (customerType) {
            this.state = customerType
        }
        this.customerTypesModal.show()
    }

    hide() {
        this.customerTypesModal.hide()
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    private get _updateMode(): boolean {
        return (this.state.id !== -1)
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this._updateMode) {
                this.update() // emits an event
            } else {
                this.create() // emits an event
            }
        }
    }
}
